import { ThunkAction } from 'components/redux/types/ThunkAction';
import { USER_LOAD_DATA_URL } from 'moduleUser/constants';
import { UserLoadDataResponseType } from 'moduleUser/actions/types/UserLoadDataResponseType';

const userLoadData = (): ThunkAction => (
  _,
  __,
  { networkService },
) => networkService.get<UserLoadDataResponseType>(USER_LOAD_DATA_URL, null).then((response) => response);

export { userLoadData };
